import { Box, DialogTitle, DialogTitleProps, Stack } from "@mui/material";
import { isEmpty } from "lodash-es";
import { ReactNode } from "react";

import AppLink from "../Link/AppLink";
import AppTypography from "../Text/AppTypography";
import { AppModalOnCloseFunc } from "./AppModal";
import { AppModalCloseIconButton } from "./AppModalCloseIconButton";

export interface AppModalTitleProps {
  withClose?: boolean;
  withLink?: boolean;
  to?: string;
  title?: ReactNode;
  subTitle?: ReactNode;
  variant?: DialogTitleProps["variant"];
  children?: DialogTitleProps["children"];
  onClose?: AppModalOnCloseFunc;
}

export default function AppModalTitle({
  title,
  subTitle,
  withClose = true,
  withLink = false,
  to,
  variant,
  children,
  onClose,
}: AppModalTitleProps) {
  return (
    <DialogTitle variant={variant || "h2"}>
      <Stack>
        {/* Title */}
        <Box sx={{ width: "100%", display: "flex", alignItems: "center" }}>
          <AppLink isEnabled={withLink || !isEmpty(to)} to={to || ""}>
            <Box sx={{ overflow: "hidden" }}>{title || children}</Box>
          </AppLink>

          <Box sx={{ ml: "auto" }}>
            {withClose && (
              <AppModalCloseIconButton onClick={() => onClose?.(undefined, "closeButtonClick")} />
            )}
          </Box>
        </Box>

        {/* Subtitle */}
        {subTitle && (
          <AppTypography sx={{ width: "100%" }} variant='body2'>
            {subTitle}
          </AppTypography>
        )}
      </Stack>
    </DialogTitle>
  );
}
